import React, {
  useMemo,
  useRef,
  useState,
  useCallback,
  useEffect,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import * as PR from "../../prime-modules/index";
import { sendPushNotifications } from "../../services/api";
import { EmojiTextArea } from "./EmojiTextArea";
import EmailManagerModal from "./email-manager-modal";

const NotificationModal = ({
  visible,
  onClose,
  searchRequest,
  userCount,
  setUserCount,
  formik,
  filterOpen,
  filterByOptions,
  affiliateNames,
  uniqueRegions,
  allCountries,
  resetUserForm,
  getNotificationsHandler,

  invalidEmails,
  setInvalidEmails,
}) => {
  const dispatch = useDispatch();
  const toast = useRef();
  const adminData = useSelector((state) => state.adminAuth.adminSessionData);
  const [loading, setLoading] = useState(false);
  const headers = useMemo(() => {
    return { sessionid: adminData.sessionId };
  }, [adminData.sessionId]);
  const [subject, setSubject] = useState("");
  const [editorText, setEditorText] = useState("");
  const [emailManagerVisible, setEmailManagerVisible] = useState(false);
  const [errors, setErrors] = useState({
    subject: "",
  });
  const sendNotificationHandler = useCallback(
    (e) => {
      setLoading(true);
      e.preventDefault();
      const newErrors = {
        subject: (subject || "").trim() === "" ? "Title is required" : "",
      };
      setErrors(newErrors);
      if (newErrors.subject || newErrors.content) {
        return setLoading(false);
      }
      let data = {}
      if (["COUNTRY", "REGION"].includes(searchRequest?.filterBy)) {
        data = {
          iso: searchRequest?.values?.[0],
          geog_type:
            searchRequest?.values?.[0] === "Global" ? "Global" : searchRequest.filterBy === "COUNTRY" ? "Local" : "Regional",
        };
      }
      const request = {
        title: subject,
        body: editorText,
        ...searchRequest,
        ...({ data })
      };
      const response = (response) => {
        if (response.result === "SUCCESS") {
          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: "Your notification has been sent successfully.",
          });
          setSubject("");
          setEditorText("");
          onClose();
          setLoading(false);
          resetUserForm();
          getNotificationsHandler();
        } else {
          const error = response.error;
          toast.current?.show({
            severity: error?.severity || "error",
            summary: "Error",
            detail: error?.errorMsg ? error.errorMsg : error?.summary,
          });
          setLoading(false);
        }
      };
      sendPushNotifications(request, headers, dispatch, response);
    },
    [subject, editorText, searchRequest, headers, dispatch, onClose, resetUserForm, getNotificationsHandler]
  );

  const isContentValid = (html) => {
    const plainText = (html || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();
    return plainText !== "";
  };

  const onHideEmailHandler = () => {
    onClose();
    setSubject("");
    setEditorText("");
    setErrors({});
    setUserCount(0);
    formik.resetForm();
  };

  useEffect(() => {
    if ((subject || "").trim() !== "") {
      setErrors((prev) => ({ ...prev, subject: "" }));
    }
  }, [subject]);

  useEffect(() => {
    if (isContentValid(editorText)) {
      setErrors((prev) => ({ ...prev, content: "" }));
    }
  }, [editorText]);
/*   const emailChipTemplate = (text) => {
    const displayText = text?.length > 10 ? text.substring(0, 10) + '…' : text;

    return <div title={text}>{displayText}</div>;
  }

  const chipChangeHandler = (e) => {
    const trimmedValues = e.value.map((email) => email.trim());

    // Remove duplicates
    const unique = [...new Set(trimmedValues)];
    // Take only first 5
    const limited = unique.slice(0, 200);
    formik.setFieldValue("email", limited);
  }; */

  const handleSaveEmails = (emails, shouldClose = true) => {
    setInvalidEmails([]);
    formik.setFieldValue("email", emails);
    if (shouldClose) {
      setEmailManagerVisible(false);
    }
    // Trigger validation/search after updating emails
    setTimeout(() => {
      formik.handleSubmit();
    }, 0);
  };

  return (
    <>
      <PR.Dialog
        header="Create Notification"
        visible={visible}
        onHide={onHideEmailHandler}
        draggable={false}
        blockScroll={true}
        resizable={false}
        dismissableMask={true}
        className="filter-dialog order-filters-dialog send-email-dialog marketing-notification-dialog"
      >
        <div className="heading-sec">
          <div
            className={`filter-right mt-2 ${filterOpen ? "mobile-filter-section" : ""
              }`}
          >
            <form autoComplete="off" onSubmit={formik.handleSubmit}>
              <div className="flex align-items-center mobile-flex">
                {/* FILTER BY */}
                <div className="users-search-input">
                  <span>
                    <PR.Dropdown
                      name="searchFilterType"
                      value={formik.values.searchFilterType}
                      options={filterByOptions}
                      placeholder="Filter By"
                      onChange={(e) => {
                        // Reset all dropdown values when filter changes
                        formik.setFieldValue("affiliateValue", "");
                        formik.setFieldValue("regionValue", "");
                        formik.setFieldValue("countryValue", "");

                        formik.setFieldValue("searchFilterType", e.value);
                      }}
                      onBlur={formik.handleBlur}
                      resetFilterOnHide
                      panelClassName="notification-dropdown-panel"
                    />
                  </span>
                  {formik.touched.searchFilterType &&
                    formik.errors.searchFilterType && (
                      <div className="error-message">
                        {formik.errors.searchFilterType}
                      </div>
                    )}
                </div>

                {/* ---------------------------------- AFFILIATE ---------------------------------- */}
                <div
                  className={`users-search-input ${formik.values.searchFilterType === "AFFILIATE"
                    ? ""
                    : "hiddenDropdown"
                    }`}
                >
                  <span>
                    <PR.MultiSelect
                      inputId="affiliate"
                      name="affiliateValue"
                      value={formik.values.affiliateValue}
                      options={affiliateNames}
                      filter
                      placeholder="Affiliate Name"
                      onChange={(e) =>
                        formik.setFieldValue("affiliateValue", e.value)
                      }
                      onBlur={formik.handleBlur}
                      resetFilterOnHide
                      maxSelectedLabels={1}
                    />
                  </span>
                  {formik.touched.affiliateValue &&
                    formik.errors.affiliateValue && (
                      <div className="error-message">
                        {formik.errors.affiliateValue}
                      </div>
                    )}
                </div>

                {/* ---------------------------------- REGION ---------------------------------- */}
                <div
                  className={`users-search-input ${formik.values.searchFilterType === "REGION"
                    ? ""
                    : "hiddenDropdown"
                    }`}
                >
                  <span>
                    <PR.MultiSelect
                      inputId="region"
                      name="regionValue"
                      value={formik.values.regionValue} // ← must be an array
                      options={uniqueRegions}
                      placeholder="All Regions"
                      optionLabel="name"
                      optionValue="iso"
                      filter
                      disabled={loading}
                      onChange={(e) => formik.setFieldValue("regionValue", e.value)}
                      onBlur={formik.handleBlur}
                      showClear
                      maxSelectedLabels={1}
                    />
                  </span>
                  {formik.touched.regionValue && formik.errors.regionValue && (
                    <div className="error-message">
                      {formik.errors.regionValue}
                    </div>
                  )}
                </div>

                {/* ---------------------------------- COUNTRY ---------------------------------- */}
                <div
                  className={`users-search-input ${formik.values.searchFilterType === "COUNTRY"
                    ? ""
                    : "hiddenDropdown"
                    }`}
                >
                  <span>
                    <PR.MultiSelect
                      inputId="country"
                      name="countryValue"
                      value={formik.values.countryValue} // MUST be array
                      options={allCountries}
                      optionLabel="name"
                      optionValue="iso"
                      filter
                      placeholder="All Countries"
                      onChange={(e) => formik.setFieldValue("countryValue", e.value)}
                      onBlur={formik.handleBlur}
                      resetFilterOnHide
                      disabled={loading}
                      showClear
                    />
                  </span>
                  {formik.touched.countryValue && formik.errors.countryValue && (
                    <div className="error-message">
                      {formik.errors.countryValue}
                    </div>
                  )}
                </div>

                {/* ---------------------------------- CUSTOMER EMAIL ---------------------------------- */}
                <div
                  className={`users-search-input ${formik.values.searchFilterType === "EMAIL"
                    ? ""
                    : "hiddenDropdown"
                    }`}
                >
                  <span>
                    <div
                      className="email-selector-field"
                      onClick={() => setEmailManagerVisible(true)}
                      style={{
                        cursor: "pointer",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "0.6rem 0.75rem",
                        minHeight: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "white",
                        width: "300px"
                      }}
                    >
                      <div style={{ flex: 1, overflow: "hidden" }}>
                        {formik?.values?.email?.length === 0 ? (
                          <span style={{ fontSize: "0.9rem" }}>
                            Click to manage customer emails
                          </span>
                        ) : (
                          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
                            <span style={{ color: "#495057" }}>
                              {formik.values.email.length} email{formik.values.email.length !== 1 ? 's' : ''} selected
                            </span>
                            {/*  {formik.values.email.slice(0, 2).map((email, idx) => (
                              <span
                                key={idx}
                                style={{
                                  backgroundColor: "#e3f2fd",
                                  padding: "0.25rem 0.5rem",
                                  borderRadius: "4px",
                                  fontSize: "0.85rem",
                                  color: "#1976d2",
                                  maxWidth: "150px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }}
                                title={email}
                              >
                                {email}
                              </span>
                            ))} */}
                            {/*   {formik.values.email.length > 2 && (
                              <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>
                                +{formik.values.email.length - 2} more
                              </span>
                            )} */}
                          </div>
                        )}
                      </div>
                      <span className="edit-pencil">
                        <i className="pi pi-pencil" />
                      </span>
                    </div>
                  </span>
                  {formik.touched.email && formik.errors.email && (
                    <div className="error-message">
                      {formik.errors.email}
                    </div>
                  )}
                </div>

                {/* ---------------------------------- BUTTONS ---------------------------------- */}
                <div className="users-search-input">
                  <span>
                    <PR.Button
                      label="Search"
                      type="submit"
                      className="searchBtn"
                    />
                    <PR.Button
                      label="Reset"
                      type="reset"
                      className="resetBtn"
                      onClick={resetUserForm}
                    />
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
        <form autoComplete="off" className="mt-0" onSubmit={sendNotificationHandler}>
          <h3>No. of Recipients: {userCount}</h3>

          <div className="grid mt-3">
            <div className="col-12 md:col-12">
              <div className="flex justify-content-between align-items-center">
                <label htmlFor="title" className="font-semibold text-base">Title<span style={{ color: "red" }}>*</span></label>
                <span className="text-xs text-red-500">(40 characters max.)</span>
              </div>
              <div className="flex flex-column align-items-center gap-2">
                <PR.InputText
                  placeholder="Title"
                  name="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  autoComplete="off"
                  className="email-input subject-input"
                  maxLength={40}
                  disabled={userCount === 0}
                />
              </div>
              {errors.subject && (
                <small className="p-error">{errors.subject}</small>
              )}
            </div>
            <div className="col-12 md:col-12">
              <div className="flex justify-content-between align-items-center">
                <label htmlFor="Message" className="font-semibold text-base">Message</label>
                <span className="text-xs ml-1 text-red-500 justify-content-end">(170 characters max.)</span>
              </div>
              <EmojiTextArea editorText={editorText} setEditorText={setEditorText} userCount={userCount} />
            </div>
          </div>
          <div className="buttons-sections flex align-items-center justify-content-end gap-3">
            <PR.Button
              label="Cancel"
              type="button"
              className="confirm-button reset-btn min-width"
              onClick={onHideEmailHandler}
            />
            <PR.Button
              label="Submit"
              disabled={loading || userCount === 0 || !subject}
              type="submit"
              className="confirm-button min-width"
            />
          </div>
        </form>
      </PR.Dialog>
      <PR.Toast ref={toast} position="top-right" />
      <EmailManagerModal
        visible={emailManagerVisible}
        onClose={() => setEmailManagerVisible(false)}
        initialEmails={formik.values.email}
        onSave={handleSaveEmails}
        invalidEmails={invalidEmails}
      />
    </>
  );
};

export default NotificationModal;
